import {NatGetEventList, SearchCondition, SearchConditionPageInfo} from './NatGetEventList'
import {NatPutEvent, PutEventInfo} from './NatPutEvent'
import Http from '../../../../network/Http'
import {SortOrder} from '../../../../components/shared/SortOrder';
import {NatGetEvent} from './NatGetEvent';
import {NatPutEventSortOrder, PutEventSortOrderParams} from './NatPutEventSortOrder';

export default class NatEventRepo {
    http: Http;

    constructor(http: Http) {
        this.http = http
    }

    // イベント一覧取得
    async getEventList(searchCondition?: SearchCondition,
                       searchConditionPageInfo?: SearchConditionPageInfo,
                       searchConditionSortInfos?: SortOrder[]): Promise<NatGetEventList> {
        const searchParams: string[] = [];
        if (searchCondition) {
            if (searchCondition.condominiumGroupId) {
                searchParams.push(`condominiumGroupId=${encodeURIComponent(searchCondition.condominiumGroupId)}`);
            }
            if (searchCondition.condominiumCd) {
                searchParams.push(`condominiumCd=${encodeURIComponent(searchCondition.condominiumCd)}`);
            }
            if (searchCondition.condominiumName) {
                searchParams.push(`condominiumName=${encodeURIComponent(searchCondition.condominiumName)}`);
            }
            if (searchCondition.deliveryTargetPrefectureCd) {
                searchParams.push(`deliveryTargetPrefectureCd=${encodeURIComponent(searchCondition.deliveryTargetPrefectureCd)}`);
            }
            if (searchCondition.deliveryTargetAddress2) {
                searchParams.push(`deliveryTargetAddress2=${encodeURIComponent(searchCondition.deliveryTargetAddress2)}`);
            }
            if (searchCondition.scheduleId) {
                searchParams.push(`scheduleId=${encodeURIComponent(searchCondition.scheduleId)}`);
            }
            if (searchCondition.scheduleStartDate) {
                searchParams.push(`scheduleStartDate=${encodeURIComponent(searchCondition.scheduleStartDate)}`);
            }
            if (searchCondition.scheduleEndDate) {
                searchParams.push(`scheduleEndDate=${encodeURIComponent(searchCondition.scheduleEndDate)}`);
            }
            if (searchCondition.condominiumEventFlag) {
                searchParams.push(`condominiumEventFlag=${encodeURIComponent(searchCondition.condominiumEventFlag)}`);
            }
        }

        if (searchConditionPageInfo) {
            if (searchConditionPageInfo.pageNum) {
                searchParams.push(`pageNum=${encodeURIComponent(searchConditionPageInfo.pageNum)}`);
            }
            searchParams.push(`page=${encodeURIComponent(searchConditionPageInfo.page)}`);
        }

        if (searchConditionSortInfos) {

            searchConditionSortInfos.forEach((sortInfo) => {
                const value: string = encodeURIComponent(`${sortInfo.sortKey}:${sortInfo.sortDirection}`);
                searchParams.push(`sortInfo=${value}`)
            })
        }

        const searchParamsText: string = searchParams.join('&');
        return await this.http.get(`/api/common/event/?${searchParamsText}`);
    }

    // イベント更新
    async putEvent(putEventInfo: PutEventInfo): Promise<NatPutEvent> {
        return await this.http.put(`/api/admin/event`, putEventInfo)
    }

    // イベント並び順更新
    async putEventSortOrder(putEventSortOrderInfo: PutEventSortOrderParams): Promise<NatPutEventSortOrder> {
        return await this.http.put(`/api/admin/event/sortOrder`, putEventSortOrderInfo)
    }

    // イベント取得
    async getEvent(scheduleId: string, seq: string): Promise<NatGetEvent> {
        return await this.http.get(`/api/common/event/${scheduleId}/${seq}`)
    }
}
